module.exports = __webpack_public_path__ + "img/softidoc.f158ebe4.png";